import { StyleSheet, Text, View } from "@react-pdf/renderer";

import React from "react";

const styles = StyleSheet.create({
  footer: {
    position: "absolute",
    fontSize: 12,
    bottom: 15,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 15,
  },
  leftText: {
    textAlign: "left",
  },
  rightText: {
    textAlign: "right",
  },
});

const PageNumber: React.FC = () => (
  <View style={styles.footer} fixed>
    <Text style={styles.leftText}>Safe.ba</Text>
    <Text
      style={styles.rightText}
      render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
    />
  </View>
);

export default PageNumber;
